import { render, staticRenderFns } from "./CourseMaterial.vue?vue&type=template&id=8b1c6396&scoped=true&"
import script from "./CourseMaterial.vue?vue&type=script&lang=js&"
export * from "./CourseMaterial.vue?vue&type=script&lang=js&"
import style0 from "./CourseMaterial.vue?vue&type=style&index=0&id=8b1c6396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c6396",
  null
  
)

export default component.exports